import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { getResolvedHeaderTickerData } from '../lib/firestore';

function serializeValue(value) {
  return JSON.stringify(value, null, 2);
}

export default function DebugHeaderTickerPage() {
  const [loading, setLoading] = useState(true);
  const [snapshot, setSnapshot] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function run() {
      setLoading(true);
      setError('');

      try {
        const [resolved, publicConfigResult, adminConfigResult] = await Promise.all([
          getResolvedHeaderTickerData({ force: true }),
          getDoc(doc(db, 'terms', 'headerTickerPublic')).then((snap) => ({
            exists: snap.exists(),
            data: snap.exists() ? snap.data() : null,
          })).catch((err) => ({
            exists: false,
            error: err?.code || err?.message || String(err),
          })),
          getDoc(doc(db, 'siteSettings', 'headerTicker')).then((snap) => ({
            exists: snap.exists(),
            data: snap.exists() ? snap.data() : null,
          })).catch((err) => ({
            exists: false,
            error: err?.code || err?.message || String(err),
          })),
        ]);

        const nextSnapshot = {
          checkedAt: new Date().toISOString(),
          currentUser: auth.currentUser
            ? {
              uid: auth.currentUser.uid,
              email: auth.currentUser.email || '',
            }
            : null,
          resolved,
          publicConfig: publicConfigResult,
          adminConfig: adminConfigResult,
        };

        console.log('[debug/header-ticker] snapshot', nextSnapshot);
        console.log('[debug/header-ticker] resolved.items', resolved?.items || []);
        console.log('[debug/header-ticker] resolved.allItems', resolved?.allItems || []);

        if (active) {
          setSnapshot(nextSnapshot);
        }
      } catch (err) {
        console.error('[debug/header-ticker] failed', err);
        if (active) {
          setError(err?.message || 'debug-failed');
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    run();
    return () => {
      active = false;
    };
  }, []);

  return (
    <>
      <Helmet><title>Drs.Farm | Header Ticker Debug</title></Helmet>
      <section className="panel">
        <Link to="/" className="detail-back-link">← トップへ戻る</Link>
        <h1>Header Ticker Debug</h1>
        <p className="page-lead">
          未ログイン状態の確認用ページです。シークレットウィンドウで開くと、公開側で何が読めているかを確認できます。
        </p>
        {loading ? <p>読み込み中...</p> : null}
        {error ? <p className="error-text">{error}</p> : null}
        {snapshot ? (
          <div className="form-grid">
            <div>
              <h2>Current User</h2>
              <pre>{serializeValue(snapshot.currentUser)}</pre>
            </div>
            <div>
              <h2>Resolved</h2>
              <pre>{serializeValue(snapshot.resolved)}</pre>
            </div>
            <div>
              <h2>Public Config</h2>
              <pre>{serializeValue(snapshot.publicConfig)}</pre>
            </div>
            <div>
              <h2>Admin Config</h2>
              <pre>{serializeValue(snapshot.adminConfig)}</pre>
            </div>
          </div>
        ) : null}
      </section>
    </>
  );
}
